import React from 'react'
import Header from '../main/Header'
import Footer from '../main/Footer'
import { Link } from 'react-router-dom'
export default function Course() {
    return (
        <>
            <Header />
            <section className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="breadcrumbs-wrap">
                                <h1 className="breadcrumb-title">Our Course</h1>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to={'/'}>Home</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Course
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="courses-section">
                <div className="sec-heading center">
                    <p>Join  &amp; Benifits</p>
                    <h2>
                        <span className="theme-cl">Our Course</span> for Learning
                    </h2>
                </div>
                <div class="container">
                    <div className="row">
                        <div className="col-md-4 mt-2">
                            {/* Web Design Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/web-design.png" alt="Web Design" />
                                </div>
                                <div class="course-info">
                                    <h4>Web Design</h4>
                                    <p>Create stunning and responsive websites.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">

                            {/* Web Development Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/web-development.jpg" alt="Web Development" />
                                </div>
                                <div class="course-info">
                                    <h4>Web Development</h4>
                                    <p>Build interactive and dynamic websites.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            {/* App Design Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/app-design.png" alt="App Design" />
                                </div>
                                <div class="course-info">
                                    <h4>App Design</h4>
                                    <p>Design intuitive and user-friendly apps.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="row mt-4 mt-2">
                        <div className="col-md-4 mb">
                            {/* App Development Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/app-development.jpg" alt="App Development" />
                                </div>
                                <div class="course-info">
                                    <h4>App Development</h4>
                                    <p>Mobile applications for iOS and Android.</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-2">


                            {/* Graphic Design Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/graphic-design.jpg" alt="Graphic Design" />
                                </div>
                                <div class="course-info">
                                    <h4>Graphic Design</h4>
                                    <p>Design beautiful visuals and graphics.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-2">

                            {/* Tally & Accounting Card  */}
                            <div class="course-card">
                                <div class="course-image">
                                    <img src="assets/images/tally.jpg" alt="Tally & Accounting" />
                                </div>
                                <div class="course-info">
                                    <h4>Tally & Accounting</h4>
                                    <p>Master accounting with Tally software.</p>
                                </div>
                            </div>
                        </div>
                    </div>







                </div>


            </section>

            <Footer />
        </>
    )
}
